module.exports = __webpack_public_path__ + "static/2-cad0c430206494e1782013f8138f0132.jpg";